export function MultipleChoiceOptionLetter({ index }: { index: number }) {
  if (index === -1) return null;
  return <>{String.fromCharCode("A".charCodeAt(0) + index)}</>;
}
